import request from '@/utils/request'

// 查询维修产品项材料定价列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/sku/material/item/page',
        method: 'get',
        params: query,
    })
}
// 查询维修产品项材料定价详细
export function getObj(id) {
    return request({
        url: '/upkeep/prod/sku/material/item/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修产品项材料定价
export function addObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用 维修首页状态
export function statusObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/status',
        method: 'post',
        data: data,
    })
}
// 修改维修产品项材料定价
export function putObj(data) {
    return request({
        url: '/upkeep/script/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修产品项材料定价
export function delObj(data) {
    return request({
        url: '/upkeep/prod/sku/material/item/delete',
        method: 'post',
        data: data,
    })
}

export function fetchMaterialItemList(query) {
    return request({
        url: '/upkeep/material/item/page',
        method: 'get',
          params: query,
    })
}
